import React, { useState } from 'react';
import { VendorStats } from '../components/vendors/VendorStats';
import { VendorList } from '../components/vendors/VendorList';
import { VendorForm } from '../components/vendors/VendorForm';
import type { Vendor } from '../types/vendor';

export const Vendors: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingVendor, setEditingVendor] = useState<Vendor | undefined>(undefined);

  const handleAddVendor = () => {
    setEditingVendor(undefined);
    setShowForm(true);
  };

  const handleEditVendor = (vendor: Vendor) => {
    setEditingVendor(vendor);
    setShowForm(true);
  };

  const handleFormSuccess = () => {
    setShowForm(false);
    setEditingVendor(undefined);
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingVendor(undefined);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Page Header */}
      <div style={{ paddingBottom: 20, borderBottom: '1px solid rgba(92,78,51,0.15)', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 400, letterSpacing: '0.4em', textTransform: 'uppercase', color: '#8a8778', marginBottom: 8 }}>
            Purchasing
          </div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 36, fontWeight: 300, color: '#1c2033', lineHeight: 1 }}>
            Vendors
          </div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, fontWeight: 300, color: '#8a8778', marginTop: 8 }}>
            Manage your vendors and supplier relationships
          </div>
        </div>
        {!showForm && (
          <button
            onClick={handleAddVendor}
            style={{
              fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 500,
              letterSpacing: '0.2em', textTransform: 'uppercase',
              background: 'linear-gradient(135deg, #d97706, #b45309)',
              color: '#1c2033', border: 'none', padding: '12px 24px',
              borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8,
            }}
            onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 32px rgba(217,119,6,0.25)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.boxShadow = 'none'; }}
          >
            <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Add Vendor
          </button>
        )}
      </div>

      <VendorStats />

      {showForm ? (
        <VendorForm
          vendor={editingVendor}
          onSuccess={handleFormSuccess}
          onCancel={handleFormCancel}
        />
      ) : (
        <VendorList
          onEditVendor={handleEditVendor}
          onSelectVendor={(vendor) => { console.log('Selected vendor:', vendor); }}
        />
      )}
    </div>
  );
};